<template>
  <div class="Carrers">
    <CareersContent></CareersContent>
  </div>
</template>

<script>
import CareersContent from '../components/careers/careersContent'
export default {
  components: {
    CareersContent,
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/page/Careers.vue